export default function Products() {
  return [
    {
      displayOrder: 1,
      productName: "Fully Underwritten Term",
      productLink: "/quote/term-life-insurance/personalizing-options",
      productIconPath: "calendar",
      openInNewTab: false,
      productTypeId: 1,
      displayName: "Term Life Insurance",
      productLandingUrl: "/landing/term",
      submittingAgentCode: null,
      hideAllProductsDefault: true,
      vssEnabled: false,
      enablePredictivePathPreQuote: false,
      enableAppointmentScheduling: true
    },
    {
      displayName: "Whole Life Insurance",
      productIconPath: "moneybag",
      productLink: "/quote/whole-life/securian-secure-promise",
      productLandingUrl: "/landing/permanent"
    },
    {
      displayName: "Children's Life Insurance",
      productIconPath: "juvenile",
      productLink: "/quote/whole-life/securian-secure-promise?juvi",
      productLandingUrl: "/landing/children"
    },
    {
      displayName: "Disability Income Insurance",
      productIconPath: "crutch",
      productLink: "/landing/disability-income",
      productLandingUrl: "/landing/disability-income"
    },
    {
      displayName: "Supplemental Insurance",
      productIconPath: "stethoscope",
      productLink: "/landing/supplemental",
      productLandingUrl: "/landing/supplemental"
    },
    {
      displayName: "Navigating Medicare",
      productIconPath: "elderly",
      productLink: "/landing/navigating-medicare",
      productLandingUrl: "/landing/navigating-medicare"
    },
    {
      displayName: "Long Term Care",
      productIconPath: "elderly",
      productLink: "/quote/long-term-care",
      productLandingUrl: "/landing/long-term-care"
    }
  ]
};